import { useGetUsers } from 'src/hooks/useGetUsers'
import { ApplicationTranslator } from 'src/translators'
import { useGetApplicationsQuery } from 'src/types/generated'

type Input = {
  projectId: string
}

export const useGetRoomApplications = ({ projectId }: Input) => {
  const { data, loading, refetch } = useGetApplicationsQuery({ variables: { projectId } })
  const { users } = useGetUsers()

  return {
    roomApplications: data
      ? ApplicationTranslator.toEntities({ response: data.applications, internalUsers: users })
      : [],
    loading,
    refetch,
  }
}
